import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";

import {
  userLoginReducer,
  medeciPsLoginReducer,
} from "./reducers/userReducers";
import { labInfoReducers } from "./reducers/labInfoReducers";
import {
  depotListReducers,
  pdfPageReducer,
  pdfPageMPSReducer,
  pdfPrintReducer,
} from "./reducers/depotReducers";
import { dossierListReducers } from "./reducers/medecinPSReducers";

const reducer = combineReducers({
  medecinPSLogin: medeciPsLoginReducer,
  userLogin: userLoginReducer,
  depotList: depotListReducers,
  pdfPage: pdfPageReducer,
  pdfPageMPS: pdfPageMPSReducer,
  pdfPrint: pdfPrintReducer,
  dossierList: dossierListReducers,
  labInfo: labInfoReducers,
});

const userInfoFromStorege = localStorage.getItem("userInfo")
  ? JSON.parse(localStorage.getItem("userInfo"))
  : null;
const tokenFromStorege = localStorage.getItem("token")
  ? JSON.parse(localStorage.getItem("token"))
  : null;
// localstorage medecin ps
const medeciPsInfoFromStorege = localStorage.getItem("medecinPSInfo")
  ? JSON.parse(localStorage.getItem("medecinPSInfo"))
  : null;
const tokenMPsFromStorege = localStorage.getItem("tokenMPS")
  ? JSON.parse(localStorage.getItem("tokenMPS"))
  : null;

const initialState = {
  userLogin: {
    userInfo: userInfoFromStorege,
    token: tokenFromStorege,
  },
  medecinPSLogin: {
    medecinPSInfo: medeciPsInfoFromStorege,
    tokenMPS: tokenMPsFromStorege,
  },
};

const middleware = [thunk];

const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
